import type { BodyRouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { EntityDataObject } from 'models/service';

type JoinCommunityBody = {
  reason?: string;
};

type JoinCommunityRouteParams = {
  id: string;
};

export const joinCommunity = async ({
  body,
  routeParams: { id },
}: BodyRouteParamsRequest<JoinCommunityBody, JoinCommunityRouteParams>) =>
  apiClient.post<EntityDataObject, ApiClientResponse<EntityDataObject>>(routes.community.join(id), body);
